import React, { Fragment, Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field, FormSpy } from 'react-final-form';
import Translate from 'react-translate-component';
import { find, isNil, path, propEq } from 'ramda';

import { getLegalOrganizations, getLegalDepartment } from 'actions/asyncActions';
import Select from 'components/common/form/Select';
import { required } from 'utils/validators';

@withAsyncActions(props => ({
    getLegalDepartment: getLegalDepartment
        .withPayload(props => ({
            company: props.legal
        }))
        .withOptions({
            dispatchOnUpdate: !isNil(props.legal),
            autoReset: true,
            dispatchOnMount: !isNil(props.legal)
        })
        .withSuccessHandler(({ getLegalDepartment: { data }, form: { change }, department }) => {
            if (data.length) {
                const item = data.length === 1 ? data[0] : find(propEq('id', Number(department)))(data || []);

                if (item) {
                    change('kadrsyst.department', item.id);
                    change('kadrsyst.departchiefkey', path(['chief', 'id'], item) || null);
                    change('kadrsyst.chief', path(['chief', 'name'], item) || '');
                    change('kadrsyst.rolecode', path(['role', 'id'], item) || null);
                } else {
                    change('kadrsyst.department', null);
                    change('kadrsyst.departchiefkey', null);
                    change('kadrsyst.chief', null);
                    change('kadrsyst.rolecode', null);
                }
            }
        })
        .withErrorHandler(({ form: { change }, department }) => {
            if (department) {
                change('kadrsyst.legal', null);
                change('kadrsyst.department', null);
                change('kadrsyst.departchiefkey', null);
                change('kadrsyst.chief', null);
                change('kadrsyst.rolecode', null);
            }
        })
}))
class LegalField extends Component {
    onLegalChange = (value, option) => {
        if (value) {
            this.props.form.change('kadrsyst.departchiefkey', path(['data', 'chief', 'id'], option) || null);
            this.props.form.change('kadrsyst.chief', path(['data', 'chief', 'name'], option) || null);
            this.props.form.change('kadrsyst.rolecode', path(['data', 'role', 'id'], option) || null);
        } else {
            this.props.form.change('kadrsyst.departchiefkey', null);
            this.props.form.change('kadrsyst.chief', null);
            this.props.form.change('kadrsyst.rolecode', null);
        }
    }

    render() {
        const { getLegalDepartment, legal, disabled } = this.props;

        return <Field
            name={'kadrsyst.department'}
            allowClear
            showSearch
            component={Select}
            options={getLegalDepartment.data}
            disabled={!legal || disabled}
            dictionaryAction={getLegalDepartment}
            label={{ content: 'request.legalDepartment', required: true }}
            className='form-control'
            placeholder={<Translate content='placeholders.chooseLegalDepartment' />}
            onChange={this.onLegalChange}
            validate={required}
        />;
    }
}

@withAsyncActions({
    getLegalOrganizations: getLegalOrganizations
        .withOptions({ dispatchOnMount: true, autoReset: true })
        .withSuccessHandler(({ getLegalOrganizations: { data }, form: { change } }) => {
            if (data.length === 1) {
                change('kadrsyst.legal', data[0].id);
            }
        })
})
export default class LegalFields extends Component {
    onLegalChange = () => {
        this.props.form.change('kadrsyst.departchiefkey', null);
        this.props.form.change('kadrsyst.chief', null);
        this.props.form.change('kadrsyst.rolecode', null);
    }

    render() {
        const {
            form,
            getLegalOrganizations: { data: organizations }, getLegalOrganizations,
        } = this.props;

        return <Fragment>
            <Field
                name='kadrsyst.legal'
                component={Select}
                options={organizations}
                dictionaryAction={getLegalOrganizations}
                label={{ content: 'request.legal', required: true }}
                placeholder={<Translate content='placeholders.chooseLegal' />}
                onChange={this.onLegalChange}
                validate={required}
            />
            <FormSpy subscription={{ values: true }}>
                { ({ values }) => (
                    <LegalField
                        form={form}
                        legal={path(['kadrsyst', 'legal'], values)}
                        department={path(['kadrsyst', 'department'], values)}
                    />
                )}
            </FormSpy>
        </Fragment>;
    }
}
